<template>
  <div class="chat-input">
    <!-- PC端输入 -->
    <div class="chat-input__pc-panel flex flex-column">
      <!-- 工具栏 开始   -->
      <!--  -->
      <input-tool
        v-if="showType === 2 && !props.invite"
        :type="1"
        :short-cuts="shortcuts"
        @emoji="handleEmoji"
        @upload="fileUpload"
        @custom="custFunc"
      />
      <!-- 工具栏 结束 -->

      <!-- 快捷短语 开始 -->
      <quick-phrase
        v-if="showType === 1 && phraseList?.length > 0"
        :phrase-list="phraseList"
        @quickPhrase="handlePhrase"
      />
      <!-- 快捷短语 结束 -->
      <div style="position: relative" @click="page.emojiVis = false">
        <chat-input-quote :quote-msg="page.quoteMsg"
          :cust-info="custInfo"
          :agent-info="agentInfo"
          @close="handleDeleteQuoteMsg"/>
        <div-editable class="chat-input__pc-edior" 
          ref="buttonRef"
          @send="sendMsg(1)"
          v-model="page.msg"
          @upload="handleUploadFile"
          :placeholder="placeholder" />
        <button class="chat-input__pc-btn" :style="{ 'background-color': themeColor }" @click="sendMsg(1)">发送</button>
      </div>
      <emotion @emotion="handleEmotion" :height="200" v-show="page.emojiVis" />
    </div>

    <!-- 移动端输入 -->
    <div class="chat-input__h5-panel">
      <!-- 快捷短语开始 -->
      <quick-phrase
        v-if="showType === 1 && phraseList?.length > 0"
        :phrase-list="phraseList"
        @quickPhrase="handlePhrase"
      />
      <!-- 快捷短语结束 -->
      <div class="chat-input__h5-editor flex flex-item-end flex-1" @click="page.emojiVis = false">
        <div-editable 
          ref="buttonRef1"
          v-click-outside="onClickOutside"
          class="chat-input__h5-edior"
          v-model="page.msg"
          @send="sendMsg(1)"
          @upload="handleUploadFile"
          :placeholder="placeholder" />
        <div class="flex flex-item-center" v-if="showType === 2 && !props.invite">
          <i class="chat-input__h5-icon iconfont icon-biaoqing" @click.stop="handleChangeInput(1)"></i>
          <i
            @click="handleChangeInput(2)"
            class="iconfont icon-circle-plus chat-input__h5-icon"
            v-if="page.msg == '' && !page.moreToolVis"
          />
          <i
            @click="handleChangeInput(2)"
            class="iconfont icon-circle-close chat-input__h5-icon"
            v-if="page.msg == '' && page.moreToolVis"
          />
        </div>
        <button
          class="chat-input__h5-btn"
          @click="sendMsg(1)"
          :style="{ 'background-color': themeColor, marginLeft: showType === 1 ? '10px' : '' }"
        >
          发送
        </button>
      </div>
      <chat-input-quote :quote-msg="page.quoteMsg"
          :cust-info="custInfo"
          :agent-info="agentInfo"
          @close="handleDeleteQuoteMsg"/>
      <!-- 工具栏 开始 -->
      <input-tool
        v-show="page.moreToolVis"
        :type="2"
        :short-cuts="shortcuts"
        :is-show-comment="isShowComment"
        :close-session-enable="closeSessionEnable"
        @upload="fileUpload"
        @custom="custFunc"
        @comment="commentClick"
        @quit="quitClick"
      />
      <!-- 工具栏 结束 -->
      <emotion class="emoji" @emotion="handleEmotion" :height="200" v-show="page.emojiVis" />
    </div>

    <!-- 文件上传 -->
    <upload-file ref="uploadRef" @sendCurMsg="handleSendCurrentMsg" @send="sendMsg" @error="handleError" />

    <!-- 禁用层 -->
    <session-mask
      :invite="invite"
      :show-type="showType"
      :session-status="sessionStatus"
      :session-error="sessionError"
      :orgId="orgId"
      @start="sessionOpenClick"
      @leave="leaveMsgClick"
    />
    <!-- 输入联想 -->
    <input-association
      :thinkConfig="page.thinkConfig"
      :orgId="orgId"
      :msg="page.msg"
      :show-type="showType"
      @associate="handleInputThink"
    />
  </div>
</template>
<script setup>
import QuickPhrase from '@/components/robot/quickPhrase.vue'
import UploadFile from '@/components/service/uploadFile.vue'
import SessionMask from '@/components/service/SessionMask.vue'
import DivEditable from '@/components/service/DivEditable.vue'
import Emotion from '@/components/Emotion/index'
import InputAssociation from '@/components/service/InputAssociation.vue'
import InputTool from '@/components/service/InputTool.vue'
import ChatInputQuote from './ChatInputQuote.vue'
import { ElMessage } from 'element-plus'
import { defineProps, ref, getCurrentInstance, computed, defineEmits, watch, reactive, nextTick } from 'vue'
import { isJSON } from '@/utils'
const props = defineProps({
  styleConfig: { type: Object, default: () => {} },
  sessionStatus: { type: Number },
  orgId: { type: String },
  showType: { type: Number, default: 1 },
  sessionError: { type: Boolean },
  closeSessionEnable: { type: Boolean, default: true },
  round: { type: Number }, //消息回合
  invite: { type: Boolean }, //会话邀请
  custInfo: { type: Object, default: () => { } },
  agentInfo: { type: Object, default: () => { } },
})
const { proxy } = getCurrentInstance()
const page = reactive({
  msg: '',
  emojiVis: false,
  moreToolVis: false,
  whiteList: [], //白名单
  whiteVisible: false,
  thinkConfig: {}, //机器人输入联想配置
  uploadLoading: false,
  quoteMsg: {}, //引用消息
})
const config = computed(() => {
  let style = props.styleConfig.styleConfig || {}
  if (style && Object.keys(style).length > 0) {
    return style
  } else {
    return {
      themeColor: '#3571F0',
      placeholder: '请输入内容...',
      pageTitle: '',
      navigatorContent: { text: '' }
    }
  }
})
const themeColor = computed(() => {
  return config.value.themeColor || '#3571F0'
  // return props.showType === 1 ? '#3571F0' : config.value.themeColor
})
const placeholder = computed(() => {
  return config.value.placeholder || '请输入内容...'
})
// 在线客服 快捷入口
const shortcuts = computed(() => {
  return config.value.shortcuts || []
})
// 在线客服评价
const isShowComment = computed(() => {
  if (props.showType === 2) {
    let commentStyle = props.styleConfig?.commentStyle
    if (commentStyle && commentStyle.enabled === 1) {
      if (
        commentStyle.custSource.mobile === 1 &&
        ((commentStyle.roundLimit.enabled === 1 && props.round > parseInt(commentStyle.roundLimit.value)) ||
          commentStyle.roundLimit.enabled === 0)
      ) {
        return true
      }
    }
  }
  return false
})
// 快捷短语
const phraseList = computed(() => {
  return props.styleConfig.phraseList || []
})
// 机器人联想输入点击
const handleInputThink = (val) => {
  page.msg = val
}
const emit = defineEmits([
  'sendMsg',
  'comment',
  'quit',
  'reconnnect',
  'leaveMsg',
  'quickPhrase',
  'sendCurrentMsg',
  'sendError',
  'seer',
  'guide'
])

const copyConten = (data) => {
  let content = {
    name: data.file?.name,
    size: data.file?.size,
    url: data.file?.url
  }
  let time = new Date().getTime()
  let type = data.type
  sendMsg(type ,content, '', time, '')
}

const sendMsg = (type, content, url, msgId) => {
  // 咨询前引导语
  if (props.showType === 2 && props.invite && /\S/.test(page.msg)) {
    emit('guide', page.msg, type)
    page.msg = null
    return
  }
  let result = {}
  result.type = type
  if (type == 1 && /\S/.test(page.msg)) {
    if (filterWhite(page.msg) || props.showType === 1) {
      result.type = props.showType === 1 ? 101 : type
      result.content = page.msg
      result.quoteMsgId = page.quoteMsg?.msgId,
      result.quoteMsgContent = Object.keys(page.quoteMsg).length > 0 ? JSON.stringify(page.quoteMsg) : null
      result.url = ''
      page.msg = ''
      page.quoteMsg = {}
      emit('sendMsg', result, msgId)
    } else {
      ElMessage.info('消息发送失败(不能发送白名单以外的超链接)')
    }
  } else if (content && content != '') {
    result.content = content
    result.url = url
    result.quoteMsgId = page.quoteMsg?.msgId,
    result.quoteMsgContent = Object.keys(page.quoteMsg).length > 0 ? JSON.stringify(page.quoteMsg) : null
    page.quoteMsg = {}
    emit('sendMsg', result, msgId)
  } else {
    ElMessage.info('请输入内容')
  }
}

// 发送粘贴板文件
const handleUploadFile = (files) => {
  emit('upload', files)
}
const buttonRef = ref()
const buttonRef1 = ref()
const handleSetInputMsg = (data) => {
  page.quoteMsg = data
  buttonRef.value.setFocus()
}
// 删除引用消息
const handleDeleteQuoteMsg = () => {
  page.quoteMsg = {}
}

const currentUrl = computed(() => {
  let protocol = window.location.protocol // 协议
  let hostname = window.location.hostname // 域名
  let port = window.location.port // 端口
  return protocol + '//' + hostname + (port ? ':' + port : '')
})
const handleEmotion = (i) => {
  // page.msg = `${page.msg}<img src="${currentUrl.value}/file/emotion/${i}.gif" align="top">`
  // if (process.env.VUE_EMOJI_TYPE === 'online'){
  //   page.msg = `${page.msg}<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${i}.gif" align="top">`
  // }
  // nextTick(() => {
  //   buttonRef1.value.handleFocusLast()
  // })
  const mediaQuery = window.matchMedia('(max-width: 960px)');
  if(mediaQuery.matches){
    buttonRef1.value.insertEmoji(i)
  } else {
    buttonRef.value.insertEmoji(i)
  }
  page.emojiVis = false
}


const handleEmoji = () => {
  page.emojiVis = !page.emojiVis
}
// 上传触发
const uploadRef = ref(null)
const fileUpload = (type) => {
  uploadRef.value.handleUploadClick(type)
}
// 提前上传图片
const handleSendCurrentMsg = (fileType, msgId, content) => {
  emit('sendCurrentMsg', fileType, msgId, content)
}
// 上传图片失败
const handleError = (id) => {
  emit('sendError', id)
}
const handleChangeInput = (type) => {
  if (type === 1) {
    page.emojiVis = !page.emojiVis
    page.moreToolVis = false
  } else {
    page.moreToolVis = !page.moreToolVis
    page.emojiVis = false
  }
}
// 评价
const commentClick = () => {
  page.moreToolVis = false
  emit('comment')
}
// 退出
const quitClick = () => {
  page.moreToolVis = false
  emit('quit')
}
// 自定义功能
const custFunc = (func) => {
  if (func.method == 1 && func.url) {
    // 外部链接
    window.open(func.url, '_blank')
  } else {
    ElMessage.info('该功能暂未开通')
  }
}
// 重启会话
const sessionOpenClick = () => {
  emit('reconnnect')
}
// 开启留言
const leaveMsgClick = () => {
  emit('leaveMsg')
}
// 过滤白名单
const filterWhite = (content) => {
  if (!page.whiteVisible) return true
  if (content.includes('https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/')) {
    // 表情包
    return true
  }
  if (page.whiteList.length === 0) return false
  if (/^https?:\/\//.test(content)) {
    return page.whiteList.some((item) => item.includes(content))
  } else {
    return true
  }
}
// 机器人快捷短语点击
const handlePhrase = (data) => {
  emit('quickPhrase', data)
}
// 获取在线客服白名单
const getWhiteList = async () => {
  let res = await proxy.$http.post('/app/custClient/whiteListAll', { orgId: props.orgId })
  if (res.code == 0) {
    page.whiteList = res.data.map((i) => i.whiteAddr) || []
  } else {
    ElMessage.error(res.msg)
  }
  let res1 = await proxy.$http.post('/app/custClient/listWhiteSwitch', { orgId: props.orgId })
  page.whiteVisible = res1 === true ? true : false
}

// 获取机器人输入联想配置
const getRobotAssociate = async () => {
  let res = await proxy.$http.post('/sys/config/getExternalVal', {
    key: 'TEXTROBOT_INPUT_THINK',
    orgId: props.orgId
  })
  if (res.code === 0) {
    if (res.data) {
      page.thinkConfig = isJSON(res.data) ? JSON.parse(res.data) : {}
    }
  } else {
    ElMessage.error(res.msg)
  }
}

watch(
  () => props.orgId,
  (newVal) => {
    if (newVal) {
      // 获取白名单链接
      getWhiteList()
    }
  },
  { immediate: true }
)
watch(
  () => props.showType,
  (newVal) => {
    page.emojiVis = false
    if (newVal && parseInt(newVal) === 1) {
      page.moreToolVis = false
    }
  },
  { immediate: true }
)

watch(
  () => props.sessionError,
  (newVal, oldVal) => {
    // 会话异常转正常发送服务先知
    if (oldVal === true && newVal === false &&page.msg&& /\S/.test(page.msg)) {
      let res = { type: 1, content: page.msg, url: '' }
      emit('seer', res)
      res = null
    }
  },
  { immediate: false }
)
defineExpose({
  getRobotAssociate,
  handleSetInputMsg,
  copyConten
})
</script>
<style scoped lang="less">
.chat-input {
  position: relative;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
  border-radius: 8px;
  &__pc-panel {
    background: #fff;
  }
  &__pc-edior {
    height: 100px;
    overflow: auto;
    padding: 10px;
    width: auto;
    font-size: 16px;
  }
  &__pc-btn {
    position: absolute;
    right: 15px;
    bottom: 15px;
    background: #3571f0;
    color: #fff !important;
    border: none;
    font-size: 14px;
    width: 64px;
    height: 32px;
    border-radius: 4px;
  }
  &__h5-panel {
    display: none;
    background: #f6f6f6;
  }
  &__h5-editor {
    padding: 10px;
    line-height: 30px;
    border-bottom: 1px solid #eee;
  }
  &__h5-edior {
    background-color: #fff;
    padding: 6px 10px;
    max-height: 100px;
    overflow-y: auto;
    font-size: 16px;
  }
  &__h5-icon {
    font-size: 24px;
    margin-right: 6px;
    color: rgb(100, 101, 109);
    &:nth-child(1) {
      margin-left: 6px;
    }
  }
  &__h5-btn {
    background: #3571f0;
    color: #fff !important;
    border: none;
    font-size: 14px;
    border-radius: 4px;
    width: 64px;
    height: 32px;
    text-align: center;
  }
  .emoji {
    /deep/ .emotion-box {
      position: static;
      width: 100%;
      background-color: #f6f6f6;
      border: none;
    }
  }
  @media screen and (max-width: 960px) {
    .chat-input__pc-panel {
      display: none;
    }

    .chat-input__h5-panel {
      display: block;
    }
  }
}
</style>
